<template>
  <span style="margin-right: 5px">
    <el-button :type="type" :size="size" @click="viewBeneficiary()">
      View
    </el-button>

    <el-dialog
      :title="info.name"
      width="80%"
      :visible.sync="dialog"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :modal="true"
      :show-close="true"
      :append-to-body="true"
    >
      <div style="text-align: right">
        <ApproveButton
          :uid="info.beneficiary_id"
          :info="info"
          v-on:onSuccess="onSuccess()"
          v-if="info.status == 'pending'"
        />
        <RejectButton
          :uid="info.beneficiary_id"
          :info="info"
          v-on:onSuccess="onSuccess()"
          v-if="info.status != 'reject'"
        />
      </div>

      <BeneInfo :info="info" v-if="info" />

      <div v-loading="loadingDocument">
        <el-upload
          class="upload-area"
          drag
          name="beneficiary_file"
          multiple
          :headers="headerUpload"
          :auto-upload="true"
          :action="actionUpload"
          :on-preview="handlePreview"
          :file-list="documentLists"
          :on-success="onSuccessUpload"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Drop file here or <em>click to upload</em>
          </div>
        </el-upload>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialog = false">Close</el-button>
      </span>
    </el-dialog>
  </span>
</template>

<script>
import BeneInfo from "./bene-info.vue";
import UploadButton from "./upload-button.vue";
import ApproveButton from "./approve-button.vue";
import RejectButton from "./reject-button.vue";
import { getToken } from "@/utils/auth";
import { getBeneficiaryDocument } from "@/api/beneficiary-monitor";
export default {
  components: {
    BeneInfo,
    UploadButton,
    ApproveButton,
    RejectButton,
  },
  props: {
    uid: {
      type: String,
      default: "",
    },
    info: Object,
    type: {
      type: String,
      default: "primary",
    },
    size: {
      type: String,
      default: "mini",
    },
  },
  data() {
    return {
      dialog: false,
      dialogImageUrl: "",

      loadingDocument: false,
      actionUpload: "",
      headerUpload: {
        authorization: getToken(),
      },

      documentLists: [],
      countuploaded: 0,
    };
  },
  methods: {
    viewBeneficiary() {
      this.dialog = true;
      this.getFileList();
    },

    mapFileList(data) {
      if (!data) return [];
      data.forEach((element) => {
        element.url = `${
          process.env.VUE_APP_SERVER_BASE_API
        }/api/beneficiary-firewall/media/${
          element.filename
        }?token=${getToken()}`;

        element.name = element.filename;
      });
      return data;
    },

    getFileList() {
      this.loadingDocument = true;
      this.actionUpload = `${process.env.VUE_APP_SERVER_BASE_API}/api/beneficiary-firewall/beneficiarys/${this.uid}/documents`;
      getBeneficiaryDocument(this.uid).then(({ result, data }) => {
        this.loadingDocument = false;
        if (result) {
          this.documentLists = this.mapFileList(data);
        }
      });
    },
    onSuccessUpload(response, file, fileList) {
      if (response.result) {
        this.countuploaded++;

        if (this.countuploaded == fileList.length) {
          this.getFileList();
          this.countuploaded = 0;
        }
      } else {
        file.name = "Upload fail - " + file.name;
        file.status = "fail";
        this.$message({
          message: response.message,
          type: "error",
          duration: 5 * 1000,
        });
      }
    },

    fileDownload(file) {
      const link = document.createElement("a");
      link.href = file.url;
      link.download = file.originFilename;
      link.target = "_blank";
      link.click();
    },

    handlePreview(file) {
      this.fileDownload(file);
    },

    onSuccess(){
      this.$emit('onSuccess')
    }
  },
};
</script>

<style>
</style>